import { render, staticRenderFns } from "./BookingDeleteConformationDialog.vue?vue&type=template&id=22d23216&scoped=true&"
import script from "./BookingDeleteConformationDialog.vue?vue&type=script&lang=js&"
export * from "./BookingDeleteConformationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d23216",
  null
  
)

export default component.exports